module.exports = __webpack_public_path__ + "static/media/mmume_09.4aee65d1.png";